export default "__VITE_ASSET__CJlIvX9a__"